<div class="form-inner-box text-primary">
    <h4 class="text-capitalize position-relative pt-3">Forgot Password</h4>
    <p>
        <small class="text-capitalize">
            No worries, we will send you instructions on how to reset your password by email.
        </small>
    </p>
    <form [formGroup]="userDetails" (ngSubmit)="forgotUser()">
        <input type="text" trim="blur" [formControl]="email" class="form-control mb-3" placeholder="Email">
        @if((userDetails.get('email')?.touched || email?.dirty || submitted ) && !userDetails.get('email')?.valid &&
        !userDetails.get('email')?.pending){
        <span class="text-danger error">
            @if(userDetails.get('email')?.errors.required){
            Email is required
            }

            @if(userDetails.get('email')?.errors.pattern){
            Please Fill Proper Email
            }
        </span>
        }

        <div class="d-flex justify-content-md-end justify-content-center align-items-center">
            <button class="btn btn-outline-success me-3" (click)="cancelForgotPassword()">Cancel</button>
            <button class="btn btn-success" type="submit">Submit</button>
        </div>
    </form>
</div>